import app from '@/app'
import store from '@/store'
import router from '@/router'
import SoundPlayer from './utils/SoundPlayer';

import '@/style/font.scss';
import '@/style/index.scss'

import mitt from 'mitt'

import '@assets/iconfont/iconFont-fill/iconfont.css'
import '@assets/iconfont/iconFont-line/iconfont.css'

import bg1 from '@assets/images/system_bg.png'
import 'element-plus/dist/index.css'
import { deployEnv } from '@/config/deployEnv'

// eslint-disable-next-line no-console
console.info('[front-uots-simulator] deploy env:', deployEnv)

const img = new Image()
img.src = bg1

//注册组件厂
import "@/components/factory.comp.ts";
import ElementPlus from 'element-plus'
import zhCn from 'element-plus/es/locale/lang/zh-cn'

app.use(ElementPlus, {
    locale: zhCn,
})


// 扩展 Window 接口
declare global {
  interface Window {
    listenEvent: ReturnType<typeof mitt>;
    playClick: () => void; 
  }
}

// 注册全局事件总线
const listenEvent = mitt();
window.listenEvent = listenEvent;
window.playClick = () => SoundPlayer.getInstance().playClick();




// 使用插件并挂载应用
app.use(store).use(router).mount('#app')
